// gif-search.component.ts
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { Subject, debounceTime } from 'rxjs';
import { GiphyService } from 'src/services/giphy.service';

@Component({
    selector: 'app-gif-search',
    templateUrl: './gif-search.component.html',
    styleUrls: ['./gif-search.component.scss'],
    standalone: false
})
export class GifSearchComponent implements OnInit, AfterViewInit {
  gifs: any[] = [];
  @Output() gifSelected = new EventEmitter<any>();
  searchTerm$ = new Subject<string>();
  @Input() searchValue: string = '';
  searchTerm: string = '';
  offset: number = 0; // For pagination
  @ViewChild('searchbar') searchbar!: IonSearchbar;

  constructor(
    private giphyService: GiphyService,
    private modalController: ModalController
  ) {}
  ngAfterViewInit(): void {
    if (!this.searchTerm) {
      setTimeout(() => this.searchbar.setFocus(), 300);
      this.searchbar.setFocus();
    }
  }

  ngOnInit(): void {
    this.searchTerm = this.searchValue;
    this.searchForGifs(this.searchTerm);

    this.searchTerm$
      .pipe(
        debounceTime(300) // Debounce time in milliseconds
      )
      .subscribe((searchTerm) => {
        this.searchForGifs(searchTerm);
      });
  }

  searchForGifs(searchTerm: string) {
    if (!searchTerm.trim()) {
      this.gifs = []; // Reset the array if the search term is empty
      this.offset = 0; // Reset offset for a new search
      return;
    }

    if (searchTerm.length <= 5) return;

    this.giphyService.searchGifs(searchTerm, this.offset).subscribe(
      (response) => {
        if (this.offset === 0) {
          this.gifs = response.data;
        } else {
          this.gifs = [...this.gifs, ...response.data]; // Append new GIFs for infinite scroll
        }
      },
      (error) => {
        console.error('Error fetching GIFs:', error);
      }
    );
  }

  loadMoreGifs(event: any) {
    this.offset += 20; // Increase offset for pagination
    this.searchForGifs(this.searchTerm); // Reuse search function for loading more GIFs
    event.target.complete(); // Complete the infinite scroll action
  }

  selectGif(gif: any) {
    this.gifSelected.emit(gif);
    this.close();
  }

  close() {
    this.modalController.dismiss();
  }
}
